import DOMPurify from "dompurify";
import { marked } from "marked";

marked.setOptions({ gfm: true, breaks: true });

export function renderAssistantMarkdown(text: string): string {
  const raw = text.trim();
  if (!raw) return "";
  const html = marked.parse(raw, { async: false }) as string;
  return DOMPurify.sanitize(html);
}
